import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getCheckedProgressChecks(studentId) {
	const companyId = getCompanyId()
	const { data, error } = await supabase
		.from('studentprogresscheckview')
		.select('progresscheckId')
		.eq('studentId', studentId)
		.eq('companyId', companyId)

	if (error) {
		throw new Error(`Error fetching checked progress checks: ${error.message}`)
	}

	return data
}

export async function getCheckedProgressCheckswithType(studentId, progresstype) {
	const companyId = getCompanyId()
	const prm = `studentId.eq.${studentId},studentId.is.null`
	const { data, error } = await supabase
		.from('studentprogresscheckview')
		.select()
		.eq('companyId', companyId)
		.or(prm)
		.eq('progresstype', progresstype)
		.order('order', { ascending: true })

	if (error) {
		throw new Error(`Error fetching checked progress checks: ${error.message}`)
	}

	return data
}

export async function checkStudentProgressCheckExists(studentId, progresscheckId) {
	const { data, error } = await supabase
		.from('studentprogresscheck')
		.select('id')
		.eq('studentId', studentId)
		.eq('progresscheckId', progresscheckId)
		.single()

	if (error && error.code !== 'PGRST116') {
		// PGRST116 indicates no result found
		throw new Error(`Error checking student progress check: ${error.message}`)
	}

	return data
}

export async function updateOrInsertStudentProgressCheck(studentId, progresscheckId, isCheck, progresstype) {
	const existingRecord = await checkStudentProgressCheckExists(studentId, progresscheckId)

	if (existingRecord) {
		// Update the existing record
		const { data, error } = await supabase.from('studentprogresscheck').update({ isCheck }).eq('id', existingRecord?.id)

		if (error) {
			throw new Error(`Error updating student progress check: ${error.message}`)
		}

		return data
	} else {
		// Insert a new record
		const { data, error } = await supabase.from('studentprogresscheck').insert({ studentId, progresscheckId, isCheck, progresstype })

		if (error) {
			throw new Error(`Error inserting student progress check: ${error.message}`)
		}

		return data
	}
}
